
import { defineComponent } from "vue";
import { Field } from "vee-validate";
import InputField from "@/views/shared/form-parts/InputField.vue";
import PullDownSelect, {
  SelectOptions,
} from "@/views/shared/form-parts/PullDownSelect.vue";
import WiFiProductList from "@/views/order-form/select-plan/component/WiFiProductList.vue";
import { Product } from "@/views/order-form/order-form-interfaces";

import { PRODUCT_CATEGORIES } from "@/views/order-form/select-plan/SelectPlan.vue";
import { string } from "yup";
import { validationMessages as message } from "@/assets/validation/validation-messages";
const PRODUCT_COVERAGE_TYPE = {
  single: "0",
  multiple: "1",
};
const MAX_WIFI_UNITS = 5;

export default defineComponent({
  name: "WiFiProductSelect",
  components: {
    Field,
    InputField,
    PullDownSelect,
    WiFiProductList,
  },
  props: {
    wifiUnit: {
      type: String,
      default: "1",
    },
    recommendedProducts: {
      type: Array as () => Product[],
      default: () => [],
    },
  },
  watch: {
    selectedWiFi: function (newVal) {
      this.$emit("updatedWiFi", newVal);
    },
    dailySingleProducts: function (newVal: Product[]) {
      if (newVal.length === 0) {
        this.formStatus.isDailyMultiplePlanOpened = true;
        return;
      }
      this.formStatus.isDailyMultiplePlanOpened = false;
    },
    packSingleProducts: function (newVal: Product[]) {
      if (newVal.length === 0) {
        this.formStatus.isPackMultiplePlanOpened = true;
        return;
      }
      this.formStatus.isPackMultiplePlanOpened = false;
    },
  },
  computed: {
    productCategories() {
      return PRODUCT_CATEGORIES;
    },
    productCoverageType() {
      return PRODUCT_COVERAGE_TYPE;
    },
    maxWiFiUnits() {
      return MAX_WIFI_UNITS;
    },
    dailySingleProducts(): Product[] {
      return this.recommendedProducts.filter((product) => {
        return (
          product.pro_typeflg === this.productCategories.daily &&
          product.pro_aroundflg === this.productCoverageType.single
        );
      });
    },
    dailyMultiProducts(): Product[] {
      return this.recommendedProducts.filter((product) => {
        return (
          product.pro_typeflg === this.productCategories.daily &&
          product.pro_aroundflg === this.productCoverageType.multiple
        );
      });
    },
    packSingleProducts(): Product[] {
      return this.recommendedProducts.filter((product) => {
        return (
          product.pro_typeflg === this.productCategories.pack &&
          product.pro_aroundflg === this.productCoverageType.single
        );
      });
    },
    packMultiProducts(): Product[] {
      return this.recommendedProducts.filter((product) => {
        return (
          product.pro_typeflg === this.productCategories.pack &&
          product.pro_aroundflg === this.productCoverageType.multiple
        );
      });
    },
    isAllDailyProductEmpty(): boolean {
      return (
        this.dailySingleProducts.length === 0 &&
        this.dailyMultiProducts.length === 0
      );
    },
    isAllPackProductEmpty(): boolean {
      return (
        this.packSingleProducts.length === 0 &&
        this.packMultiProducts.length === 0
      );
    },
  },
  data() {
    return {
      selectedWiFi: "",
      validRules: {
        wifiProduct: string().required(message.required),
      },
      formStatus: {
        tabIndex: 1,
        isDailyMultiplePlanOpened: false,
        isPackMultiplePlanOpened: false,
      },
    };
  },
  methods: {
    onChangeProductTab(event: Event): void {
      if (event.target instanceof HTMLInputElement) {
        this.formStatus.tabIndex = Number(event.target.value);
      }
    },
    prepareUnitOptions(): SelectOptions[] {
      return Array(this.maxWiFiUnits)
        .fill({})
        .map((elm, index): SelectOptions => {
          return {
            label: index + 1 + "台",
            value: String(index + 1),
          };
        });
    },
    onChange(event: Event): void {
      if (!(event.target instanceof HTMLSelectElement)) return;
      this.$emit("update:wifiUnit", event.target.value);
    },
  },
  emits: ["update:wifiUnit", "updatedWiFi"],
});
